import { Controller } from "stimulus";
const {
  eachWeekOfInterval,
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
  startOfISOWeek,
  endOfISOWeek,
  isSameMonth,
} = require("date-fns");

export default class extends Controller {
  static targets = ["popup"];

  connect() {
    this.popupVisible = false;
  }

  handleTime(el) {
    el.stopPropagation();
    el.preventDefault();

    this.popupVisible = !this.popupVisible;
    const options = {
      hours: this.getNumberMatrix(Array.from(this.range(0, 23, 1))),
      minutes: this.getNumberMatrix(Array.from(this.range(0, 55, 5))),
      days: this.getNumberMatrix(Array.from(this.range(1, 30, 1))),
    };
    const isPopup = el.target.getAttribute("data-target");
    const isCustomClock = el.target.classList.contains("custom-clock");

    if (!this.popupVisible) {
      if (document.querySelectorAll("#custom-popup").length >= 1) {
        for (
          let i = 0;
          i < document.querySelectorAll("#custom-popup").length;
          i++
        ) {
          document
            .querySelectorAll("#custom-popup")
            [i].parentNode.removeChild(
              document.querySelectorAll("#custom-popup")[i]
            );
        }
      }
    }

    if (
      isCustomClock ||
      el.target.getAttribute("type") === "hours" ||
      el.target.getAttribute("type") === "minutes"
    ) {
      if (this.popupVisible) {
        const popupEl = document.createElement("div");
        const hourEl = document.createElement("p");
        const hourTable = document.createElement("table");
        const minutesEl = document.createElement("p");
        const minutesTable = document.createElement("table");
        const time = el.target.querySelector(".hour");
        const minute = el.target.querySelector(".minute");

        popupEl.setAttribute("id", "custom-popup");
        popupEl.setAttribute("data-target", "popup");

        hourEl.textContent = "Hours";
        hourEl.setAttribute("data-target", "popup");
        popupEl.appendChild(hourEl);

        this.setTableRow(hourTable, options.hours, "hours", time.textContent);
        popupEl.appendChild(hourTable);

        minutesEl.textContent = "Minutes";
        minutesEl.setAttribute("data-target", "popup");
        popupEl.appendChild(minutesEl);

        this.setTableRow(
          minutesTable,
          options.minutes,
          "minutes",
          minute.textContent
        );
        popupEl.appendChild(minutesTable);

        el.target.appendChild(popupEl);
      } else {
        const popupEl = this.popupTarget;
        const type = el.target.getAttribute("type");
        const time = popupEl.parentElement.querySelector(".hour");
        const minute = popupEl.parentElement.querySelector(".minute");
        const input = popupEl.parentElement.querySelector(
          ".custom-clock-value"
        );

        this.clearTableValues(el.target.parentElement.parentElement);

        if (type === "hours") {
          time.innerText = el.target.textContent;
          el.target.classList.add("active");
        } else if (type === "minutes") {
          minute.innerText = el.target.textContent;
          el.target.classList.add("active");
        }

        const convertTime = `${time.textContent}:${minute.textContent}`;
        if (input) input.value = convertTime;
      }
    }
  }

  updateTable(element, monthIdx, start, end) {
    const daysTable = document.createElement("table");
    element.removeChild(element.querySelector("table"));
    this.setTableRowDate(
      daysTable,
      monthArray[monthIdx].weeksArray,
      start,
      end
    );
    element.appendChild(daysTable);
  }

  closeCurrentPopup(node) {
    node.parentNode.removeChild(node);
  }

  clearUlValues(nodes) {
    nodes.forEach((el) => {
      if (el.classList.contains("active")) {
        el.classList.remove("active");
      }
    });
  }

  clearTableValues(el) {
    el.childNodes.forEach((el) => {
      el.childNodes.forEach((el) => {
        if (el.classList.contains("active")) {
          el.classList.remove("active");
        }
      });
    });
  }

  setTableRow(el, numbers, type, value, secondValue) {
    var tbdy = document.createElement("tbody");
    numbers.map((row) => {
      var tr = document.createElement("tr");
      row.map((r) => {
        var td = document.createElement("td");
        if (
          (type === "hours" && value == r) ||
          (type === "minutes" && value == r)
        ) {
          td.classList.add("active");
        }

        td.setAttribute("type", type);
        td.setAttribute("data-target", "popup");
        td.appendChild(document.createTextNode(r < 10 ? "0" + r : r));
        tr.appendChild(td);
      });
      tbdy.appendChild(tr);
    });

    el.appendChild(tbdy);
  }

  setTableRowDate(el, numbers, startDate, endDate) {
    var tbdy = document.createElement("tbody");
    numbers.map((row) => {
      var tr = document.createElement("tr");
      row.map((r) => {
        var td = document.createElement("td");
        if (r.disabled) {
          td.classList.add("disabled");
        }

        if (startDate == r.date || endDate == r.date) {
          td.classList.add("active");
        } else if (startDate < r.date && r.date < endDate) {
          td.classList.add("range");
        }

        td.setAttribute("type", "day");
        td.setAttribute("data-target", "popup");
        td.setAttribute("data-date", r.date);
        td.appendChild(document.createTextNode(r.number));
        tr.appendChild(td);
      });
      tbdy.appendChild(tr);
    });

    el.appendChild(tbdy);
  }

  getNumberMatrix(arr) {
    var rows = [];
    var currIdx = 0;
    arr.forEach((num, i) => {
      if (i % 6 === 0) {
        rows.push([]);
        currIdx++;
      }
      rows[currIdx - 1].push(num);
    });

    return rows;
  }

  range(start, end, step) {
    const result = [];
    for (let i = start; i <= end; i += step) {
      result.push(i);
    }
    return result;
  }

  getMountMatrix({ year, mount }, convertDate = (val) => val) {
    const date = new Date(year, mount);
    const matrix = eachWeekOfInterval(
      {
        start: startOfMonth(date),
        end: endOfMonth(date),
      },
      {
        weekStartsOn: 1,
      }
    );

    return matrix.map((weekDay) =>
      eachDayOfInterval({
        start: startOfISOWeek(weekDay),
        end: endOfISOWeek(weekDay),
      }).map((day) =>
        this.convertDate(day, {
          isSameMonth: isSameMonth(date, day),
        })
      )
    );
  }
}
